
import Header from "./components/header"
import Video from "./components/video"
import Slider from "./components/slider"
// import VerticalList from "./components/verticalList"
import Form from "./components/form"
import JobForm from "./components/jobForm"
import News from "./components/news"
import TeamMemberPopin from "./components/teamMemberPopin"
import CustomSelect from "./components/customSelect"
import JobOfferSelect from "./components/jobOfferSelect"


const main = {
    init: function () {
        Header.init();
        Video.init();
        Slider.init();
        // VerticalList.init();
        Form.init();
        News.init();
        TeamMemberPopin.init();
        JobForm.init();
        JobOfferSelect.init();
        CustomSelect.init();
    }
}

export default main